import { SidebarMatchable } from './types';

const toPathname = (value: string) => {
  const [pathname] = value.split(/[?#]/);

  return pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
};

export const isRouteActive = (currentPath: string, route?: string) => {
  if (!route) {
    return false;
  }

  const current = toPathname(currentPath);
  const target = toPathname(route);

  if (target === '/') {
    return current === '/';
  }

  return current === target || current.startsWith(`${target}/`);
};

export const isSidebarItemActive = (currentPath: string, item: SidebarMatchable) => {
  const { to, routes = [to] } = item;

  return routes.some((route) => isRouteActive(currentPath, route));
};
